export default __webpack_public_path__ + "static/media/banner_luyen_thi.aa61bab1.png";